import { Component, Input } from '@angular/core';
import { TouchSelectionCircleElementsManager } from 'devexpress-richedit/lib/base/canvas/renderes/selection-renderers/touch-selection-circle-elements-manager';

@Component({
  selector: 'validation-errors',
  templateUrl: './validation-errors.component.html',
  styleUrls: ['./validation-errors.component.scss'],
})
export class ValidationErrorsComponent{

  @Input() control;
  @Input() min;
  @Input() max;

  constructor() { }
}
